import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../../utils/constants';

import history from '../../history';
import routes from '../../utils/routes';

import {
    saveTemplateTest,
    saveQuestionsTemplateTest,
} from '../../utils/common-functions';

function* asyncAddTemplateTest({
    payload: {
        labelTest,
        typeTest,
        maxDuration,
        minOptions,
        maxOptions,
        percentual,
        createNewTest,
        questions,
        amountQuestions,
    },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });
        const data = {
            label: labelTest,
            test_type: typeTest,
            questions_per_test: amountQuestions,
            min_options: minOptions,
            max_options: maxOptions,
            max_duration: maxDuration,
            approval_percent: percentual,
        };

        const response = yield call(saveTemplateTest, data);

        if (questions && questions.length > 0) {
            yield call(saveQuestionsTemplateTest, {
                testId: response.data.id,
                data: {
                    questions,
                },
            });
        }

        yield put({
            type: actions.CHANGE_SUCCESS_ADD_TEMPLATE_TEST,
            payload: true,
        });
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        if (!createNewTest) {
            history.push(routes.TEMPLATE_TESTS);
        }
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }
}

export default function* addTemplateTest() {
    yield takeEvery(actions.ASYNC_ADD_TEMPLATE_TEST, asyncAddTemplateTest);
}



// WEBPACK FOOTER //
// ./src/components/add-template-test/add-template-test.saga.js